var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMigrated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Migrated") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "migrated",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#FF6C11",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons/migrated",
    transform: "translate(2.000000, 2.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333333,2.16666667 L13.3333333,3.16666667 L3.16666667,3.16666667 L3.16666667,12.8333333 L13.3333333,12.8333333 L13.3333333,13.8333333 L2.16666667,13.8333333 L2.16666667,2.16666667 L13.3333333,2.16666667 Z M10.6783902,5.33333333 L13.3333333,8 L10.6783902,10.6666667 L9.87809735,9.86283991 L11.062,8.67233333 L6,8.67323123 L6,7.43160865 L11.167,7.43133333 L9.87809735,6.13716009 L10.6783902,5.33333333 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMigrated);
export default __webpack_public_path__ + "static/media/migrated.9b404773ac6a0cac600b08dd793d6f1d.svg";
export { ForwardRef as ReactComponent };